
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55.699 55.699"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.51 18.001a.958.958 0 00-.05-.248c-.012-.034-.02-.067-.035-.1a.988.988 0 00-.194-.291v-.001l-.001-.002L34.161.293a.978.978 0 00-.295-.197c-.027-.013-.057-.02-.086-.03a.998.998 0 00-.265-.053C33.494.011 33.475 0 33.453 0H22.177a6.677 6.677 0 00-6.669 6.67v1.674h-4.663a6.677 6.677 0 00-6.67 6.67V49.03a6.677 6.677 0 006.67 6.669h22.677a6.676 6.676 0 006.669-6.669v-1.675h4.664a6.676 6.676 0 006.669-6.669V18.069c0-.024-.012-.044-.014-.068zM34.454 3.414l13.655 13.655h-8.985a4.675 4.675 0 01-4.67-4.67V3.414zm3.737 45.615a4.675 4.675 0 01-4.669 4.669H10.845a4.675 4.675 0 01-4.67-4.669V15.014a4.675 4.675 0 014.67-4.67H21.122v10.399a6.675 6.675 0 006.668 6.669h10.4v18.942l.001 2.675zm-1.414-23.617h-8.986a4.673 4.673 0 01-4.668-4.669v-8.985l13.654 13.654zm8.078 19.943h-4.664V26.412c0-.023-.012-.044-.014-.067a.973.973 0 00-.049-.249c-.012-.033-.021-.066-.036-.1a.977.977 0 00-.194-.29l-.001-.002L22.829 8.637a1.006 1.006 0 00-.295-.196c-.029-.013-.058-.021-.088-.031a.946.946 0 00-.263-.053c-.021-.002-.04-.013-.062-.013h-4.614V6.67A4.675 4.675 0 0122.176 2h10.277v10.4a6.677 6.677 0 006.67 6.67h10.399v21.616a4.672 4.672 0 01-4.667 4.669z"}})])
          )
        }
      }
    